import { MapPin, Navigation, Phone, MessageCircle } from "lucide-react";
import { MAPS_QUERY } from "@/data/content";
import { SectionHeading } from "@/components/site/primitives";
import { useSiteConfig } from "@/context/SiteConfigContext";
import { telHref, waHref } from "@/lib/links";

export function LocationSection() {
  const { config } = useSiteConfig();
  return (
    <section className="relative py-20 sm:py-28 bg-[#F7F5EF]" data-testid="location-section">
      <div className="container-x">
        <SectionHeading overline="Location" title="Right Here in Port Harcourt"
          subtitle="Conveniently located on the St. John's Campus." />
        <div className="mt-12 grid lg:grid-cols-2 gap-8 items-stretch">
          <div className="rounded-sm border border-slate-200 bg-white p-8">
            <div className="flex items-start gap-3">
              <MapPin size={24} className="mt-1 shrink-0 text-[#C0202A]" />
              <div>
                <h3 className="font-serif text-xl font-bold text-[#0A1E4E]">School of Basic Studies</h3>
                <p className="mt-1 text-slate-600 leading-relaxed">
                  St. John's Campus, Aba Road<br />Port Harcourt, Rivers State, Nigeria
                </p>
              </div>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3">
              <a href={`https://www.google.com/maps/search/?api=1&query=${MAPS_QUERY}`} target="_blank" rel="noopener noreferrer" className="btn-navy" data-testid="location-directions">
                <Navigation size={16} /> Get Directions
              </a>
              <a href={telHref(config.phonePrimary)} className="btn-gold" data-testid="location-call">
                <Phone size={16} /> Call Us
              </a>
              <a href={waHref(config.whatsapp)} target="_blank" rel="noopener noreferrer" className="btn-red" data-testid="location-whatsapp">
                <MessageCircle size={16} /> WhatsApp Us
              </a>
            </div>
          </div>
          <div className="overflow-hidden rounded-sm border border-slate-200 min-h-[20rem]">
            <iframe
              title="School of Basic Studies location map"
              src={`https://www.google.com/maps?q=${MAPS_QUERY}&output=embed`}
              className="h-full w-full min-h-[20rem]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="location-map"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
